import { debounceEvent } from './_debounce';

document.addEventListener( 'DOMContentLoaded', function() {
	'use strict';

	var bodyWidth = document.getElementsByTagName( 'body' )[0].offsetWidth,
		menuItem = document.querySelectorAll( '.menu-primary.-description > .menu-item-has-children' );

	// Check if we have mega menus.
	if ( menuItem.length === 0 ) {
		return;
	}

	// Position the menu.
	var positionMenu = function( el ) {
		var menuItemPosition = el.getBoundingClientRect().left,
			megaMenu = el.querySelector( ':scope > .sub-menu' ),
			megaMenuWidth = parseInt( getComputedStyle( megaMenu ).width, 10 );

		if ( bodyWidth - menuItemPosition < megaMenuWidth ) {
			el.classList.add( '-edge' );
			megaMenu.classList.add( '-edge' );
		} else {
			el.classList.remove( '-edge' );
			megaMenu.classList.remove( '-edge' );
		}
	};

	// Position mega menus on load.
	[].forEach.call( menuItem, function( el ) {
		positionMenu( el );
	} );

	// Reposition after window resize.
	var repositionMenu = debounceEvent( function() {
		bodyWidth = document.getElementsByTagName( 'body' )[0].offsetWidth;

		if ( bodyWidth > 768 ) {
			[].forEach.call( menuItem, function( el ) {
				positionMenu( el );
			} );
		}
	}, 100 );

	window.addEventListener( 'resize', repositionMenu );
} );
